import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styled from "@emotion/styled";
import { db } from "../../firebase.js";
import { doc, getDoc } from "firebase/firestore";
import { colors } from "../../utils/colors.js";
import { ReactComponent as Ring } from "../../assets/icons/Ring.svg";
import dayjs from "dayjs";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 36px;
  max-width: 1040px;
  direction: rtl;
  width: 100vw;
  overflow: hidden;
  padding-top: 40px;
  padding-bottom: 40px;
  margin-top: 0;
`;
export const InvTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 16px;
  font-family: Rubik;
  font-size: calc(16px + 3vmin);
  line-height: normal;

  font-style: normal;
  font-weight: 700;
  padding: 0 20px;
`;
export const InvLogoContainer = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  justify-content: center;
  align-items: center;
`;
export const InvLogo = styled.img`
  height: auto;
  min-height: 10vh;
  padding-bottom: 40px;
  margin-bottom: 16px;
  // width: 70vw;
  display: flex;

  @media (max-width: 920px) {
    width: 75vw;
  }
  @media (max-width: 550px) {
    width: 100vw;
  }
`;

const BadgesContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  height: 80px;
  gap: 24px;
  position: absolute;
  bottom: 5px;
`;

const Badge = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  min-height: 79px;
  min-width: 65px;
  max-height: 79px;
  max-width: 65px;
  box-shadow: 0px 2px 8px 0px rgba(122, 0, 57, 0.3);
  border-radius: 8px;

  text-shadow: 0px 2px 8px rgba(122, 0, 57, 0.3);
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: #ffffff;
`;

const BadgeHourLabel = styled.span`
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: #ffffff;
`;

const IntroTextLabel = styled.span`
  margin-top: 8px;
  margin-bottom: 34px;
  text-align: center;
  font-family: Rubik;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: "#202020";
  width: 50vw;
  padding: 0 20px;

  @media (max-width: 920px) {
    width: 75vw;
  }
  @media (max-width: 550px) {
    width: 97vw;
  }
`;
const TableDetailsLabel = styled.span`
  margin-bottom: 8px;
  text-align: center;
  font-family: Rubik;
  font-size: 56px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: "#202020";
  width: 50vw;
  padding: 0 20px;

  @media (max-width: 920px) {
    width: 75vw;
  }
  @media (max-width: 550px) {
    width: 97vw;
  }
`;

const LocationLabel = styled.span`
  margin-top: 8px;

  text-align: center;
  font-family: Rubik;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: "#202020";
  padding: 0 20px;
`;

function TablePage() {
  let { invitationId, guestId } = useParams();
  const [invitation, setInvitation] = useState({});
  const [guest, setGuest] = useState({});

  useEffect(() => {
    //get event details
    const docInvRef = doc(db, "invitations", invitationId);
    getDoc(docInvRef)
      .then((docSnap) => {
        const eventData = docSnap.data();
        const eventDate = new Date(eventData.eventDate.toDate());

        setInvitation({ ...eventData, eventDate: dayjs(eventDate) });
      })
      .catch((e) => {
        console.error(e?.message);
      });

    //get contact details
    const docGuestRef = doc(db, "guests", guestId);
    getDoc(docGuestRef)
      .then((docSnap) => {
        setGuest({ ...docSnap.data() });
      })
      .catch((e) => {
        console.error(e?.message);
      });
  }, [invitationId, guestId]);

  return (
    <Container
      style={{
        borderStyle: "solid",
        borderWidth: 5,
        borderColor: colors[invitation?.invitationColor],
      }}
    >
      <Ring
        style={{
          width: "15%",
          minWidth: 50,
          fill: colors[invitation?.invitationColor],
          marginBottom: 8,
        }}
      />
      <InvTitle
        style={{
          color: colors[invitation?.invitationColor],
        }}
      >
        {invitation?.title}
      </InvTitle>
      <InvLogoContainer>
        <InvLogo src={invitation?.imageUrl} />
        <BadgesContainer>
          <Badge
            style={{
              backgroundColor: colors[invitation?.invitationColor],
            }}
          >
            קבלת פנים
            <BadgeHourLabel>{invitation?.receptionTime}</BadgeHourLabel>
          </Badge>
          {invitation?.huppaDescription && (
            <Badge
              style={{
                backgroundColor: colors[invitation?.invitationColor],
              }}
            >
              {invitation?.huppaDescription}
              <BadgeHourLabel>{invitation?.huppaTime}</BadgeHourLabel>
            </Badge>
          )}
          {invitation?.dancingDescription && (
            <Badge
              style={{
                backgroundColor: colors[invitation?.invitationColor],
              }}
            >
              {invitation?.dancingDescription}
              <BadgeHourLabel>{invitation?.dancingTime}</BadgeHourLabel>
            </Badge>
          )}
        </BadgesContainer>
      </InvLogoContainer>
      <IntroTextLabel>{`${guest.name} ${
        guest.guestsInvited > 1 ? "היקרים" : "היקר/ה"
      }, \b השולחן שהוקצה לכם הוא:`}</IntroTextLabel>
      <TableDetailsLabel
        style={{
          color: colors[invitation?.invitationColor],
        }}
      >{`שולחן ${guest.tableNumber}`}</TableDetailsLabel>
      <LocationLabel>{invitation.eventAddress}</LocationLabel>
    </Container>
  );
}

export default TablePage;
